import { render, staticRenderFns } from "./consolidated-container-details.vue?vue&type=template&id=9ac6b43e"
import script from "./consolidated-container-details.vue?vue&type=script&lang=js"
export * from "./consolidated-container-details.vue?vue&type=script&lang=js"
import style0 from "./consolidated-container-details.vue?vue&type=style&index=0&id=9ac6b43e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports